export abstract class GroundProfile {

    public abstract getGroundHeight(x : number, t : number) : number;

    public abstract getGroundSlope(x : number, t : number) : number;

}



// WEBPACK FOOTER //
// D:/[Projects]/WebSPH.gits/WebSPH.git/src/simulation/ground/GroundProfile.ts